import { isEmpty } from 'lodash'
const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_ID

export const intercomInitialiser = () =>
  `(function(){var w=window;var ic=w.Intercom;
    if(typeof ic==="function"){ic('reattach_activator');
    ic('update',w.intercomSettings);}
    else{var d=document;
    var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;
    var l=function(){var s=d.createElement('script');s.type='text/javascript';
    s.async=true;s.src='https://widget.intercom.io/widget/${INTERCOM_APP_ID}';
    var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};
    if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();`

declare global {
  interface Window {
    Intercom: any
  }
}

const isLoggedAsAdmin = (user: any) =>
  ['platform_admin', 'site_admin', 'hub_admin', 'project_admin'].includes(
    user.roleName,
  )

export const intercomNode = ({ intercom, user }: any) => {
  // Don't render Intercom on the participant side and on development and if user is not an admin

  if (window && !isEmpty(intercom) && isLoggedAsAdmin(user)) {
    return window?.Intercom?.('boot', {
      app_id: INTERCOM_APP_ID,
      ...intercom,
    })
  }
  return
}

export const trackIntercomEvent = (eventName: string) =>
  window?.Intercom?.('trackEvent', eventName)
